import { DiffType } from '@ardoq/data-model';

export type VisualDiffClassName =
  | 'visual-diff-placeholder'
  | 'visual-diff-added'
  | 'visual-diff-removed'
  | 'visual-diff-changed'
  | 'visual-diff-unchanged';

const diffTypeToCssClass = new Map<DiffType, VisualDiffClassName | ''>([
  [DiffType.NONE, ''],
  [DiffType.PLACEHOLDER, 'visual-diff-placeholder'],
  [DiffType.ADDED, 'visual-diff-added'],
  [DiffType.REMOVED, 'visual-diff-removed'],
  [DiffType.CHANGED, 'visual-diff-changed'],
  [DiffType.UNCHANGED, 'visual-diff-unchanged'],
]);

export const getCssClassFromDiffType = (diffType: DiffType = DiffType.NONE) =>
  diffTypeToCssClass.get(diffType) || '';
